import { HubConnection } from "@microsoft/signalr";
import { create } from "zustand";

type SignalRContextType = {
  connection: HubConnection | null;
  isConnected: boolean;
  setConnection: (connection: HubConnection | null) => void;
  setIsConnected: (isConnected: boolean) => void;

};

export const useSignalRContext = create<SignalRContextType>((set) => ({
  connection: null,
  isConnected: false,
  setConnection: (connection: HubConnection | null) => set({ connection }),
  setIsConnected: (isConnected: boolean) => set({ isConnected }),
}));
